import { ErrorString, InvalidOperationException } from "../../shared/index.js";
export const minAsync = async (source, selector) => {
    let min = null;
    for await (const item of source) {
        min = Math.min(min ?? Number.POSITIVE_INFINITY, await selector(item));
    }
    if (min === null) {
        throw new InvalidOperationException(ErrorString.NoElements);
    }
    else {
        return min;
    }
};
